// Le bandeau de fin d'accès à Radar (issue #111).
//
// Un compte sans accès (essai fini, ni abonnement ni accès offert) garde tout
// ce qui se lit ; ce bandeau dit pourquoi la veille s'est arrêtée et pourquoi
// certains gestes sont refusés (402 `abonnement_requis`, src/web/accesRadar.ts).
// Le serveur refuse de toute façon : l'écran ne fait que rendre ce refus lisible.
// « S'abonner » mène à la page d'abonnement (#109).

import { CircleAlert, Clock } from 'lucide-react'
import { useT } from '../lib/i18n'
import { navigate } from '../lib/router'
import { fullDate, parseDate } from '../lib/format'

/** Le bandeau de fin d'essai s'affiche les sept derniers jours (#112), comme
 *  le premier rappel par mail. */
export const JOURS_AVANT_FIN_ESSAI = 7

export function essaiFinitBientot(essaiJusquA: string | null | undefined, maintenant = Date.now()): boolean {
  const fin = parseDate(essaiJusquA ?? null)?.getTime()
  return fin !== undefined && fin > maintenant && fin - maintenant <= JOURS_AVANT_FIN_ESSAI * 86_400_000
}

/** L'essai finit dans moins d'une semaine : une ligne, et le chemin vers les formules. */
export function BandeauEssai({ jusqua }: { jusqua: string }) {
  const t = useT()
  return (
    <div className="bandeau-taches" role="status">
      <div className="tache">
        <Clock size={15} />
        <b>{t('acces.essai.fin', { date: fullDate(jusqua) })}</b>
        <button className="btn-primary btn-sm" onClick={() => navigate('#/abonnement')}>{t('acces.essai.choisir')}</button>
      </div>
    </div>
  )
}

export function BandeauAcces() {
  const t = useT()
  return (
    <div className="bandeau-taches" role="status">
      <div className="tache tache-erreur">
        <CircleAlert size={15} />
        <b>{t('acces.fin.titre')}</b>
        <span>{t('acces.fin.texte')}</span>
        <button className="btn-primary btn-sm" onClick={() => navigate('#/abonnement')}>{t('abonnement.sAbonner')}</button>
      </div>
    </div>
  )
}

/**
 * Un paiement a échoué (issue #116) : l'accès tient pendant la grâce
 * (`GRACE_PAIEMENT_JOURS`, packages/auth), et ce bandeau envoie mettre la
 * carte à jour au portail Stripe avant qu'elle ne s'achève.
 */
export function BandeauPaiement() {
  const t = useT()
  return (
    <div className="bandeau-taches" role="status">
      <div className="tache tache-erreur">
        <CircleAlert size={15} />
        <b>{t('abonnement.enRetard')}</b>
        <button className="btn-primary btn-sm" onClick={() => navigate('#/abonnement')}>{t('abonnement.mettreAJour')}</button>
      </div>
    </div>
  )
}
